import React  from "react"
import makeStyles from "@mui/styles/makeStyles"
import FormControl from "@mui/material/FormControl"
import Input from "@mui/material/Input"
import InputLabel from "@mui/material/InputLabel"

const fieldOverrides = {
    "& .MuiInputLabel-root": { color: "#555555" },
    "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": { color: "#555555" },
    "& .MuiInput-underline:before": { borderBottomColor: "#DBDBDB" },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: "#BDBDBD",
        borderBottomWidth: 1,
    },
    "& .MuiInput-underline:after": { borderBottomWidth: 1 },
}

const useStyles = makeStyles({
    textField: {
        marginTop: 20,
        width: "100%",
        fontSize: 16,
        ...fieldOverrides,
    },
    errorField: {
        color: "#F44259",
        marginTop: 7,
        fontSize: 13,
        lineHeight: "18px",
    }
})

const LoginForm = (props) => {
    const { values, errors, handleChange, handleBlur } = props
    const classes = useStyles()

    return (
        <>
            <FormControl className={classes.textField} variant="standard" error={!!errors.username}>
                <InputLabel>Email</InputLabel>
                <Input
                    name="username"
                    type="email"
                    value={values.username}
                    onChange={handleChange}
                />
                {errors.username && (
                    <div className={classes.errorField}>{errors.username}</div>
                )}
            </FormControl>
            <FormControl className={classes.textField} variant="standard" error={!!errors.password}>
                <InputLabel>Mot de passe</InputLabel>
                <Input
                    name="password"
                    type="password"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.password && (
                    <div className={classes.errorField}>{errors.password}</div>
                )}
            </FormControl>
        </>
    )
}

export default LoginForm
